module.exports = __webpack_public_path__ + "static/media/chess-bishop-alt.ecf967ae.svg";